import React, { Component } from 'react';
export default class Mask extends Component {
  constructor (props) {
    super(props);
    this.state = {}
  }
 render() {
   return (
    <div className={'mask'}
         style={{display: this.props.visible ? 'block': 'none'}}
         onClick={() => {
           this.props.onClick && this.props.onClick()
         }
         }>
      {this.props.children}
    </div>
  )
 }
}
